import { render } from "./02_Campus.vue?vue&type=template&id=c1f58202&scoped=true"
import script from "./02_Campus.vue?vue&type=script&lang=js"
export * from "./02_Campus.vue?vue&type=script&lang=js"

import "./02_Campus.vue?vue&type=style&index=0&id=c1f58202&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1f58202"]])

export default __exports__